import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["backdrop", "title"];

  connect() {
    if (this.element.classList.contains('scroll-revealed')) {
      window.addEventListener('scroll', (e) => {
        this.backdropTarget.style.opacity = window.scrollY > 180 ? 1 : 0;
        this.titleTarget.style.opacity = window.scrollY > 200 ? 1 : 0;
      })
    }
  }
}